export default {
  sales: state => state.sales,
  salesById : state => state.salesById
}
